import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCylinder = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2 2.83333V12.9967C2 13.5271 2.63214 14.0358 3.75736 14.4109C4.88258 14.786 6.4087 14.9967 8 14.9967C9.5913 14.9967 11.1174 14.786 12.2426 14.4109C13.3679 14.0358 14 13.5271 14 12.9967V2.83333M14 3C14 4.10457 11.3137 5 8 5C4.68629 5 2 4.10457 2 3C2 1.89543 4.68629 1 8 1C11.3137 1 14 1.89543 14 3Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCylinder;
